import React from 'react';
import Group from "./Group"
import {Link} from "react-router-dom";

export default function Groups() {

    const [groups, setGroups] = React.useState();
    
    if (groups === undefined) {
        fetch(process.env.REACT_APP_API_URL + "/group/list", {
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("BEARER_TOKEN")
            }
        })
        .then(response => {
            if (response.status === 401) {
                localStorage.removeItem("BEARER_TOKEN");
            } else {
                return response.json()
            }
        })
        .then((response) => {
            setGroups(response)
        })
    }   
    return (<>
        {groups && groups.sort((a, b) => {
            let aa = new Date(a.created_at.replace(" ", "T"));
            let bb = new Date(b.created_at.replace(" ", "T"));
            return aa < bb ? 1 : -1}).map(group => 
            <Link to={"/group/" + group.id} key={group.id}><Group group={group} /></Link>
        )}

    </>)


}
